import React, { Component, PropTypes } from 'react';
import Modal from 'components/Modal';
import { translate as t } from 'lang';
import GoogleMapLocation from 'components/GoogleMapLocation';
import './GoogleWaypointMapDialog.scss';

class GoogleWaypointMapDialog extends Component {

    static propTypes = {
        countries: PropTypes.array,
        address: PropTypes.object,
        onClose: PropTypes.func,
        onSelectLocation: PropTypes.func,
        onMapSave: PropTypes.func,
    };

    state = {
        map: null,
        mark: null,
        selectedLocation: null,
        selectedCoords: null,
    };

    _onDialogClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    _onDialogSave = (modal) => {

        //console.log(this.state.selectedLocation);


        if (!this.state.selectedLocation) {
            alert(t('NO_SELECTED_LOCATION_ON_MAP'));
            return false;
        }



        var transformedLocation = this.state.selectedLocation;
        transformedLocation.text = transformedLocation.city_full;
        transformedLocation.coords = transformedLocation.coords;

        if (this.props.onSelectLocation) {
            this.props.onSelectLocation.call(null, transformedLocation);
        }

        if (this.props.onMapSave) {
            this.props.onMapSave();
        }

        modal.modal('hide');
    };


    _geocodedDataMap = (geocodedData) => {

        let suggestion = {};
        suggestion.coords = [geocodedData.coords.lng, geocodedData.coords.lat];
        suggestion.city_full = geocodedData.formatted_address;
        suggestion.country = geocodedData.country;
        suggestion.country_name = geocodedData.country_name;
        suggestion.country_iso = geocodedData.country_iso;
        suggestion.region = geocodedData.region;
        suggestion.area = geocodedData.area;
        suggestion.city = geocodedData.city;
        suggestion.street = geocodedData.street;
        suggestion.home = geocodedData.street_number;
        suggestion.postal_code = geocodedData.postal_code;
        suggestion.need_calibration = false;



        this.setState({
            selectedLocation: suggestion,
            selectedCoords: geocodedData.coords,
        });

    };

    render() {
        var modalTitle = 'Укажите точку на карте';

        return (
            <div className="GoogleWaypointMapDialog">
                <Modal
                    title={modalTitle}
                    content={<GoogleMapLocation
                        zoom={11}
                        address={this.props.address}
                        onGeocodedData={this._geocodedDataMap}
                    ></GoogleMapLocation>}
                    onClose={this._onDialogClose}
                    onSave={this._onDialogSave}/>
            </div>
        );
    }
}

export default GoogleWaypointMapDialog;



// WEBPACK FOOTER //
// ./client/components/GoogleWaypointMapDialog/GoogleWaypointMapDialog.js